<template>
  <div>
    <toggle-collapse>
      <b-card style="position: relative" :title="$t('Filter Plans')">
        <b-row class="mt-2">
          <b-col sm="12" md="6">
            <b-form-group :label="$t('Owners')" label-for="vi-devices-id">
              <v-select multiple :close-on-select="false" v-model="request.owners"
                :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" :getOptionLabel="d => d.name"
                :options="[...owners]" :reduce="d => d.id"
                v-on:input="reFilterPlans('owners', Object.assign(request)), refilterContractByOwner(request.owners)" />
              <small v-if="errors && ('owners' in errors)" class="text-danger">
                {{ $t(errors['owners'][0]) }}
              </small>
            </b-form-group>
          </b-col>
          <b-col sm="12" md="6">
            <b-form-group :label="$t('contracts')" label-for="vi-devices-id">
              <v-select multiple :close-on-select="false" v-model="request.contracts"
                :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" :getOptionLabel="d => d.name"
                :options="[...contracts]" :reduce="d => d.id" v-on:input="reFilterPlans('contracts', request)" />
              <small v-if="errors && ('contracts' in errors)" class="text-danger">
                {{ $t(errors['contracts'][0]) }}
              </small>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card>

    </toggle-collapse>

    <!-- form report -->
    <b-card style="position: relative" :title="$t('Select Plan & Time')">
      <div v-if="loading" class="loading_page">
        <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'" />
      </div>
      <b-form @submit.prevent="getReport" class="">
        <b-row class="mt-2">
          <b-col :cols="report_type == 'report' ? 6 : 12">
            <b-form-group :label="$t('plans')" label-for="vi-plan-id">
              <v-select multiple :close-on-select="false" v-model="request.plans"
                :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" :getOptionLabel="d => d.name"
                :options="[{ name: $t('all'), id: 'all' }, ...plans]" :reduce="d => d.id" />
              <small v-if="errors && ('plans' in errors)" class="text-danger">
                {{ $t(errors['plans'][0]) }}
              </small>
            </b-form-group>
          </b-col>

          <b-col v-if="report_type == 'report'" md="6" sm="6">
            <!-- report range date -->
            <b-form-group :label="$t('Select Start Date To End Date')" label-for="report-date" :state="null">
              <flat-pickr v-model="rangeDate" :state="null" class="form-control" :config="{ ...pickerOptions }"
                placeholder=" new Date()" />

              <b-form-invalid-feedback v-if="errors && (('from' in errors) || ('to' in errors))"
                :state="errors && (('from' in errors) || ('to' in errors)) ? false : null">
                {{ ('from' in errors) ? errors['from'][0] : '' }}
                {{ ('to' in errors) ? errors['to'][0] : '' }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>

          <b-col :cols="report_type == 'report' ? 6 : 12">
            <b-form-group :label="$t('work days')" label-for="work_days" :state="null">
              <b-form-checkbox-group v-model="request.workDays" :options="daysOptions" name="flavour-1a">
              </b-form-checkbox-group>
              <b-form-invalid-feedback v-if="errors && ('workDays' in errors)"
                :state="errors && ('workDays' in errors) ? false : null">
                {{ errors.workDays[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>

        </b-row>
        <b-row class="mt-2">
          <!-- reset and submit -->
          <b-col v-if="report_type == 'report'" cols="12">
            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="submit" variant="primary" class="mr-1">
              {{ $t('Get Report') }}
            </b-button>
          </b-col>

          <b-col v-if="report_type == 'setting'" cols="12">
            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="button" variant="primary" class="mr-1"
              @click="saveDialySetting('garden')">
              {{ $t('Save Setings') }}
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-card>
    <div v-if="report_data">
      <DataTable 
          :report_data="report_data" 
          :report_fields="report_fields"
          :filter_included_fields="filter_included_fields" 
          :request="request" 
          :errors="errors" 
          :loading="dataTableloading||loading"
          :getReport="getReport" 
          :total="total" 
          :from="from" 
          :to="to"  
          :sortData="sortData" 
      />

    </div>

  </div>
</template>

<script>

import {
  BButton, 
  BTable, 
  BFormInvalidFeedback, 
  BCard, 
  BCol, 
  BFormCheckboxGroup,
  BForm, 
  BFormCheckbox, 
  BFormRadioGroup, 
  BFormGroup, 
  BFormInput, 
  BPagination,
  BInputGroup, 
  BInputGroupPrepend, 
  BRow, 
  BAlert, 
  BTabs, 
  BTab, 
  BCardText, 
  VBTooltip,
  BInputGroupAppend,
} from 'bootstrap-vue'

import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import { OrbitSpinner } from 'epic-spinners'

import { ref, onMounted } from '@vue/composition-api'
import reportLogic from '@/app/reports/ContainerAreaPlan/logic'

import reportForm from '@/app/reports/ContainerAreaPlan/reportForm'
import ToggleCollapse from '@/views/ui/toggle-collapse/ToggleCollapse.vue'
import DataTable from '@/views/reports/data-table/DataTable.vue'

import { ReportSetting } from '@/views/reports/ReportSettings'

import ReportOptions from '@/views/reports/components/options.js'

export default {
  name: 'ContainerAreaPlanReport',
  components: {
    BRow,
    BCard, 
    BFormCheckboxGroup, 
    BTable, 
    BPagination,
    BCol, 
    BFormRadioGroup, 
    BFormInvalidFeedback,
    BAlert,
    BFormGroup,
    BFormInput, 
    flatPickr,
    BFormCheckbox,
    BInputGroup,
    BInputGroupPrepend,
    BForm,
    BButton,
    BTabs,
    BCardText,
    BTab,
    vSelect,
    OrbitSpinner, 
    BInputGroupAppend,
    ToggleCollapse,
    DataTable
  },
  directives: {
    Ripple, 'b-tooltip': VBTooltip,
  },
  props: {
    report_type: {
      type: String,
      default: 'report'
    }
  },

  setup(props, { root }) {

    const tableRef = ref(null)
    const rangeDate = ref('')

    const { 
      owners, 
      contracts, 
      plans, 
      reFilterPlans 
    } = reportForm()

    const { 
      report_data, 
      request, 
      errors, 
      loading, 
      getReport, 
      total, 
      from, 
      to,
      isSortDirDesc,
      sortBy,
      dataTableloading
    } = reportLogic()

    const sortData = (data)=>{
      sortBy.value = data.sortBy
      isSortDirDesc.value = data.isSortDirDesc
    }

    const filter_included_fields = ['id', 'device', 'date', 'day', 'plan', 'area', 'visit', 'times', 'durations', 'serveCount', 'percent', 'owner', 'contract']
    const { pickerOptions } = ReportOptions(request.value)

    const report_fields = [
      {
        key: 'index',
        label: 'id',

      },
      {
        key: 'owner',
        label: 'owner',
        sortable: true

      },
      {
        key: 'contract',
        label: 'contract',
        sortable: true
      },

      {
        key: 'device',
        label: 'device',
        sortable: true
      },
      {
        key: 'plan',
        label: 'plan',
        sortable: true
      },
      {
        key: 'date',
        label: 'date',
        sortable: true
      },
      {
        key: 'period',
        label: 'Period',
        sortable: true
      },
      {
        key: 'planCount',
        label: 'plan dump count',
        sortable: true

      },
      {
        key: 'planServeCount',
        label: 'plan  dump serve count',
        sortable: true

      },
      {
        key:'outOfPlan',
        label:'Out Of Plan dump count',
        sortable:true
      },
      {
        key: 'percent',
        label: 'percent',
        sortable: true
      },
    ]


    const daysOptions = [
      { text: root.$t('Saturday'), value: 'Saturday' },
      { text: root.$t('Sunday'), value: 'Sunday' },
      { text: root.$t('Monday'), value: 'Monday' },
      { text: root.$t('Tuesday'), value: 'Tuesday' },
      { text: root.$t('Wednesday'), value: 'Wednesday' },
      { text: root.$t('Thursday'), value: 'Thursday' },
      { text: root.$t('Friday'), value: 'Friday' },
    ]

    const groupByOptions = [
      { text: 'Device', value: 'device' },
      { text: 'Day', value: 'day' },
    ]

    const reportMethodsOptions = [
      { text: 'Weight', value: 'weight' },
      { text: 'Area Enter/Exit', value: 'enterOrExit' },
    ]

    const report_wrapper = ref(null)

    /// here use root form as dialy report setting

    const toaster = (msg, variant, title) => {
      root.$root.$bvToast.toast(msg, {
        title,
        variant,
        solid: true,
      })
    }

    const saveDialySetting = (reportName) => {
      let setting_data = request.value;
      delete setting_data.to;
      delete setting_data.from;

      ReportSetting.setSettings(reportName, setting_data).then((res) => {
        toaster(root.$root.$t('settigs saved succeffly!!'), 'scuccess', root.$root.$t('success!!'))
      })
        .catch(reason => reason.status === 422 ? errors.value = reason.data.errors : {})
    }

    onMounted(() => {
      if (props.report_type == "setting") {
        ReportSetting.getSetting('containerArea').then((res) => {
          request.value = res;
        })
      }
    })

    const refilterContractByOwner = (owners_ids) => {
      let result = contracts.value.filter((i) => owners_ids.includes(i.contractor_id));
      contracts.value = JSON.parse(JSON.stringify(result));  
    if (owners_ids.length == 0) { contracts.value = JSON.parse(JSON.stringify(contracts.value)) }
    }

    //here end of   dialy report setting
    return {
      report_data, 
      report_fields, 
      filter_included_fields, 
      total, 
      from, 
      to, 
      rangeDate,
      tableRef,
      getReport,
      pickerOptions,
      report_wrapper,
      groupByOptions,
      daysOptions,
      reportMethodsOptions,
      request,
      loading,
      errors,
      owners, 
      contracts, 
      plans,
      reFilterPlans,
      refilterContractByOwner,
      reportLogic,
      //dialy report setting
      saveDialySetting,
      sortData,
      dataTableloading
    }

  },

}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.repeater-form {
  overflow: hidden;
  transition: .35s height;
}

.group-row {
  background-color: #ddd;
}
</style>
